import { useSinglePeriodGLSummaryColumns } from 'src/assets/static/action_required_invoices/SinglePeriodGLSummaryColumns';
import GridWrapper from 'src/components/GridWrapper';
import { IGlSummary } from 'src/services/useActionRequiredInvoicesApi';

const defaultProps = {
  DataItemKey: 'rowId',
  sortable: false,
  resizable: true,
  showColumnMenu: false,
};

interface SinglePeriodGLSummaryProps {
  glSummaries: IGlSummary[];
}

const SinglePeriodGLSummary = ({ glSummaries }: SinglePeriodGLSummaryProps) => {
  const singlePeriodGLSummaryColumns = useSinglePeriodGLSummaryColumns();
  return (
    <GridWrapper
      className="auto-scrollbar"
      columns={singlePeriodGLSummaryColumns}
      dataSource={glSummaries}
      total={0}
      {...defaultProps}
    />
  );
};

export default SinglePeriodGLSummary;
